import React from 'react';
import { brand } from '../../config/brand';
import { useReveal } from '../../hooks/useReveal';
import SplitText from '../SplitText';
import './Process.css';

const Process: React.FC = () => {
  const ref = useReveal();

  return (
    <section className="process section" id="process" aria-labelledby="process-heading" ref={ref}>
      <div className="container">
        <span className="section-label">How We Work</span>
        <h2 className="section-title reveal" id="process-heading">
          <SplitText text="A process built for predictable delivery" highlight="predictable delivery" />
        </h2>
        <p className="section-subtitle reveal reveal-delay-1">
          No black boxes. No surprises. You'll always know where things stand, what's coming next,
          and what it costs.
        </p>

        <ol className="process__steps">
          {brand.process.map((step, i) => (
            <li className={`process__step reveal reveal-delay-${i + 1}`} key={step.step}>
              <span className="process__step-number" aria-hidden="true">{step.step}</span>
              <h3 className="process__step-title">{step.title}</h3>
              <p className="process__step-desc">{step.description}</p>
              <p className="process__step-deliverable">
                <span className="process__step-deliverable-label">You get </span>
                {step.deliverable}
              </p>
            </li>
          ))}
        </ol>

        {/* Engagement models — priced shapes, so "studio" doesn't turn into an
            open-ended scope conversation on the first call. */}
        <div className="process__engagements">
          <div className="process__engagements-head reveal">
            <h3 className="process__engagements-title">Three ways to work with us</h3>
            <p className="process__engagements-sub">
              Pick the shape that fits. Each one has a defined end, a defined deliverable, and a
              price agreed before we start.
            </p>
          </div>

          <div className="process__engagement-grid">
            {brand.engagements.map((engagement, i) => (
              <article
                className={`process__engagement card reveal reveal-delay-${i + 1}${engagement.featured ? ' process__engagement--featured' : ''}`}
                key={engagement.name}
              >
                {engagement.featured && (
                  <span className="process__engagement-flag">Most common</span>
                )}
                <div className="process__engagement-head">
                  <h4 className="process__engagement-name">{engagement.name}</h4>
                  <span className="process__engagement-length">{engagement.length}</span>
                </div>
                <p className="process__engagement-outcome">{engagement.outcome}</p>
                <ul className="process__engagement-list">
                  {engagement.includes.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
                <span className="process__engagement-terms">{engagement.terms}</span>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
